import log from 'salvo-lite/log'

import OverlayScrollBar from 'overlayscrollbars'

class ScrollBar {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._scrollElem = this._elem.querySelector('[data-scroll-track]') || this._elem
        this._options = this._getOptions()
        this._scrollTriggers = this._elem.querySelectorAll('[data-scroll-trigger]')
        this._scrollBar = null
    }

    onInit () {
        log.debug(this._name, 'Initiated', this)
        this._scrollBar = new OverlayScrollBar(this._scrollElem, this._options)
    }

    _attachEvent () {
        log.debug(this._name, 'Initialized', this)
        let mouseDown = false
        let oldX = 0
        let newX = 0
        let calc = 0
        this._scrollElem.addEventListener('mousedown', e => {
            this._scrollElem.classList.add('moving')
            mouseDown = true
            oldX = e.clientX
        })

        this._scrollElem.addEventListener('mousemove', e => {
            if (!mouseDown) return false
            newX = e.clientX
            calc = oldX - newX
            oldX = newX
            if (calc !== 0) this._moveScrollBar(calc)
        })

        document.body.addEventListener('mouseup', e => {
            this._scrollElem.classList.remove('moving')
            log.debug(this._name, 'MOUSE UP', e)
            mouseDown = false
        })

        for (let trigger of this._scrollTriggers) {
            trigger.addEventListener('click', e => {
                e.preventDefault()
                this._scrollBar.scroll(JSON.parse(trigger.dataset.scrollTrigger), 1000)
            })
        }
    }

    _moveScrollBar (calc) {
        this._scrollBar.scroll({ x: `+= ${calc}` })
    }

    _getOptions () {
        return {
            className: 'os-theme-minimal-dark',
            callbacks: {
                onInitialized: e => this._attachEvent()
            }
        }
    }
}

export default ScrollBar



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ScrollBar.js